import type { Enum } from '@partou/core';

export const DEVELOPMENT_DOMAINS = [
  'grove-motoriek',
  'fijne-motoriek',
  'taal',
  'cognitief',
  'sociaal-emotioneel',
] as const;

export type DevelopmentDomain = Enum<typeof DEVELOPMENT_DOMAINS>;
